<div *ngIf="_tile != null">
  <div class="mat-elevation-z3" style="padding: 5px 5px 5px 5px;">
    <div class="dynamicLayoutTileTitle" *ngIf="_tile.Name != null">{{ _tile.Name }}</div>

    <!-- HTMLTABLE -->
    <div *ngIf="_tile.Renderer == 'HTMLTABLE'">
      <app-dynamic-layout-html-table [tile]="_tile" [values]="values">
      </app-dynamic-layout-html-table>
    </div>

    <!-- GRID -->
    <div *ngIf="_tile.Renderer == 'GRID'">
      <app-dynamic-layout-grid [dynamicLayoutTile]="_tile" [dynamicLayoutId]="_tile.DynamicLayoutId" [dynamicLayoutDataSource]="dynamicLayoutDataSource">
      </app-dynamic-layout-grid>
    </div>
  </div>
</div>
